/* ============ Theme JS ============ */

// Scroll to image in gallery
function scrollToImage(index) {
  const gallery = document.getElementById('mainImageGallery');
  const targetImg = document.getElementById('img-' + index);
  if (gallery && targetImg) {
    gallery.scroll({
      left: targetImg.offsetLeft - gallery.offsetLeft,
      behavior: 'smooth'
    });
    document.querySelectorAll('.thumbnail').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.thumbnail')[index]?.classList.add('active');
  }
}

// Track scroll to update active thumbnail
function handleGalleryScroll() {
  const gallery = document.getElementById('mainImageGallery');
  if (!gallery) return;
  const scrollPos = gallery.scrollLeft;
  const images = gallery.querySelectorAll('img');
  let activeIndex = 0;
  
  images.forEach((img, index) => {
    if (Math.abs((img.offsetLeft - gallery.offsetLeft) - scrollPos) < (img.offsetWidth / 2)) {
      activeIndex = index;
    }
  });
  
  document.querySelectorAll('.thumbnail').forEach((t, idx) => {
    t.classList.toggle('active', idx === activeIndex);
  });
}

function buyNow() {
  const variantButton = document.querySelector('.variant-btn.active');
  const variantId = variantButton ? variantButton.dataset.variantId : '';

  if (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => {
      window.location.href = '/checkout';
    })
    .catch(err => {
      window.location.href = '/checkout';
    });
  } else {
    window.location.href = '/checkout';
  }
}

// Variant Selector
function selectVariant(btn, price, comparePrice, label) {
  document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const currentPrice = document.getElementById('priceDisplay');
  const oldPrice = document.getElementById('compareDisplay');
  const badge = document.getElementById('saveBadge');
  const packLabel = document.getElementById('packLabel');
  if (currentPrice) currentPrice.textContent = 'Rs.' + price.toLocaleString() + '.00';
  if (oldPrice) oldPrice.textContent = 'Rs.' + comparePrice.toLocaleString() + '.00';
  if (badge) {
    const discount = Math.round(((comparePrice - price) / comparePrice) * 100);
    badge.textContent = '✓ SAVE ' + discount + '%';
  }
  if (packLabel) packLabel.textContent = label;
}

function bindProductInteractions() {
  document.querySelectorAll('.thumbnail').forEach((thumb, idx) => {
    thumb.addEventListener('click', () => scrollToImage(idx));
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scrollToImage(idx);
      }
    });
  });

  const gallery = document.getElementById('mainImageGallery');
  if (gallery) {
    gallery.addEventListener('scroll', () => {
      clearTimeout(gallery.scrollTimeout);
      gallery.scrollTimeout = setTimeout(handleGalleryScroll, 100);
    });
  }

  document.querySelectorAll('.variant-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const price = Number(btn.dataset.price || 0);
      const comparePrice = Number(btn.dataset.comparePrice || 0);
      const label = btn.dataset.label || btn.textContent.trim();
      selectVariant(btn, price, comparePrice, label);
    });
  });

  const menuToggle = document.querySelector('.header__hamburger');
  const menu = document.querySelector('.mobile-menu');
  const closeButton = document.querySelector('.mobile-menu__close');
  const overlay = document.querySelector('.mobile-menu-overlay');

  if (menuToggle && menu && closeButton && overlay) {
    const setMenuState = (isOpen) => {
      menu.classList.toggle('active', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('menu-open', isOpen);
    };

    menuToggle.addEventListener('click', () => {
      setMenuState(!menu.classList.contains('active'));
    });

    closeButton.addEventListener('click', () => setMenuState(false));
    overlay.addEventListener('click', () => setMenuState(false));
  }
}



// Live Viewer Count Animation (changes every 5 seconds)
function animateViewerCount() {
  const el = document.getElementById('viewerCount');
  if (!el) return;
  const numbers = [41, 38, 30, 50, 44, 33, 47, 36, 52, 29, 45, 39, 48, 31, 42];
  let i = 0;
  setInterval(() => {
    i = (i + 1) % numbers.length;
    el.style.opacity = '0';
    setTimeout(() => {
      el.textContent = numbers[i];
      el.style.opacity = '1';
    }, 300);
  }, 5000);
}

// Dynamic Delivery Dates
function setDeliveryDates() {
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const today = new Date();
  
  function suffix(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
  
  function fmt(date) {
    return months[date.getMonth()] + ' ' + date.getDate() + suffix(date.getDate());
  }

  const d1 = document.getElementById('date1');
  const d2 = document.getElementById('date2');
  const d3 = document.getElementById('date3');

  const orderDate = new Date(today);
  const deliverDate = new Date(today); deliverDate.setDate(today.getDate() + 5);

  if (d1) d1.textContent = fmt(orderDate);
  if (d2) d2.textContent = fmt(orderDate);
  if (d3) d3.textContent = fmt(deliverDate);
}

// Init on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  bindProductInteractions();
  animateViewerCount();
  setDeliveryDates();
});
